function getPhoneMaskByCountry(country) {
    const masks = {
        'Россия':       ['+', '7', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
        'Беларусь':     ['+', '3', '7', '5', ' ', '(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
        'Украина':      ['+', '3', '8', '0', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
        'Казахстан':    ['+', '7', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
        'Узбекистан':   ['+', '9', '9', '8', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
        'Туркменистан': ['+', '9', '9', '3', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
        'Киргизия':     ['+', '9', '9', '6', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
        'Таджикистан':  ['+', '9', '9', '2', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
        'Азербайджан':  ['+', '9', '9', '4', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
        'Армения':      ['+', '3', '7', '4', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
        'Грузия':       ['+', '9', '9', '5', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
        'Эстония':      ['+', '3', '7', '2', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
        'Латвия':       ['+', '3', '7', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
        'Литва':        ['+', '3', '7', '0', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
        'Молдова':      ['+', '3', '7', '3', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
        'ОАЭ (Дубай)':  ['+', '9', '7', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
        'default':      ['+', '7', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]
    };

    return masks[country] || masks['default'];
}

  function getCountryCode(country) {
    console.log(country)

    switch (country) {
      case 1: // Russia
        return '7';
      case 42: // Belarus
          return '375';
      case 48: // Kazakhstan
          return '7';
      case 15: // Kyrgyzstan
          return '996';
      case 41: // Armenia
          return '374';
      default:
        return '7';
    }
  }

  export function codeToCode(code) {
    switch (code) {
      case 1: // Russia
        return 'ru';
      case 42: // Belarus
          return 'by';
      case 48: // Kazakhstan
          return 'kz';
      case 15: // Kyrgyzstan
          return 'kg';
      case 41: // Armenia
          return 'am';
      default:
        return 'ru';
    }
  }

  function getCountryFrom(invoiceData) {
    if (invoiceData.cityFromCountryCode) {
      return invoiceData.cityFromCountryCode;
    }

    return 1;
  }

  function getCountryTo(invoiceData) {
    if (invoiceData.cityToCountryCode) {
      return invoiceData.cityToCountryCode;
    }

    return 1;
  }

  function formatPhoneNumber(input, country) {
    if (!input.trim()) {
      return ''; // Return an empty string if input is empty
    }
  
    const defaultCountryCode = getCountryCode(country);
  
    // Handle specific input cases, e.g., Russia +7 (8...)
    if (defaultCountryCode === '7' && input.startsWith("+7 (8")) {
      input = input.replace("+7 (8", "+7 (8");
    }
  
    // Allow only digits plus basic formatting characters
    const allowedChars = ['+', '(', ')', '-', ' '];
    let sanitized = '';
    for (const char of input) {
      if (/\d/.test(char) || allowedChars.includes(char)) {
        sanitized += char;
      }
    }
  
    // Determine the prefix from the input
    const startsWithPlus = sanitized.startsWith('+');
    const digitsOnly = sanitized.replace(/\D/g, '');
  
    // Build prefix and handle digits
    let prefix = `+${defaultCountryCode}`;
    let remainingDigits = digitsOnly;
    if (startsWithPlus && digitsOnly.startsWith(defaultCountryCode)) {
      remainingDigits = digitsOnly.substring(defaultCountryCode.length);
    }
  
    // Adjust based on country-specific formatting
    let formatted = prefix;
    switch (defaultCountryCode) {
      case '7': // Russia, Kazakhstan
        // Format: +7 (XXX) XXX-XX-XX
        if (remainingDigits.length > 0) formatted += ` (${remainingDigits.substring(0, 3)}`;
        if (remainingDigits.length > 3) formatted += `) ${remainingDigits.substring(3, 6)}`;
        if (remainingDigits.length > 6) formatted += `-${remainingDigits.substring(6, 8)}`;
        if (remainingDigits.length > 8) formatted += `-${remainingDigits.substring(8, 10)}`;
        break;
  
      case '375': // Belarus
        // Format: +375 (XX) XXX-XX-XX
        if (remainingDigits.length > 0) formatted += ` (${remainingDigits.substring(0, 2)}`;
        if (remainingDigits.length > 2) formatted += `) ${remainingDigits.substring(2, 5)}`;
        if (remainingDigits.length > 5) formatted += `-${remainingDigits.substring(5, 7)}`;
        if (remainingDigits.length > 7) formatted += `-${remainingDigits.substring(7, 9)}`;
        break;
  
      case '380': // Ukraine
        // Format: +380 (XX) XXX-XX-XX
        if (remainingDigits.length > 0) formatted += ` (${remainingDigits.substring(0, 2)}`;
        if (remainingDigits.length > 2) formatted += `) ${remainingDigits.substring(2, 5)}`;
        if (remainingDigits.length > 5) formatted += `-${remainingDigits.substring(5, 7)}`;
        if (remainingDigits.length > 7) formatted += `-${remainingDigits.substring(7, 9)}`;
        break;
  
      case '998': // Uzbekistan
        // Format: +998 (XX) XXX-XX-XX
        if (remainingDigits.length > 0) formatted += ` (${remainingDigits.substring(0, 2)}`;
        if (remainingDigits.length > 2) formatted += `) ${remainingDigits.substring(2, 5)}`;
        if (remainingDigits.length > 5) formatted += `-${remainingDigits.substring(5, 7)}`;
        if (remainingDigits.length > 7) formatted += `-${remainingDigits.substring(7, 9)}`;
        break;
  
      default:
        // Generic format: +<country code> (XXX) XXX-XX-XX
        if (remainingDigits.length > 0) formatted += ` (${remainingDigits.substring(0, 3)}`;
        if (remainingDigits.length > 3) formatted += `) ${remainingDigits.substring(3, 6)}`;
        if (remainingDigits.length > 6) formatted += `-${remainingDigits.substring(6, 8)}`;
        if (remainingDigits.length > 8) formatted += `-${remainingDigits.substring(8, 10)}`;
    }
  
    return formatted;
  }

  export {formatPhoneNumber, getCountryCode, getCountryFrom, getCountryTo}